var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.pos === 'normal' ? 'normal' : 'abs',attrs:{"id":"footer"}},[_vm._v(" Copyright © 2016 - 2020 天下网络 All Right Reserved ")])}
var staticRenderFns = []

export { render, staticRenderFns }